import React from "react";

const ComingSoon = () =>{
    return (
        <h1> Coming Soon</h1> 
    )
}

export default ComingSoon;